import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {LOCATIONS_ROUTES} from '../constants'

const LocationsIndex = React.lazy(() => import('./screens/LocationsIndex'))
const ViewLocationContainer = React.lazy(
  () => import('./screens/ViewLocation/components/ViewLocationContainer'),
)

function LocationsRoutes() {
  return (
    <Switch>
      <Route path={LOCATIONS_ROUTES.VIEW_LOCATION}>
        <ViewLocationContainer />
      </Route>

      <Route path={LOCATIONS_ROUTES.__ROOT__}>
        <LocationsIndex />
      </Route>

      <Redirect to={LOCATIONS_ROUTES.__ROOT__} />
    </Switch>
  )
}

// used for code-splitting
// eslint-disable-next-line import-x/no-default-export
export default LocationsRoutes
export {LocationsRoutes}
